var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v2-spinner",class:("v2-spinner--" + _vm.size)},[_c('div',{staticClass:"v2-spinner__circle"}),(_vm.label)?_c('span',{staticClass:"v2-spinner__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }